import { withRouter } from 'react-router-dom';
import BaseCadernos from '../../base/testes/BaseCadernos';

class Cadernos extends BaseCadernos {

}

export default withRouter(Cadernos);
